export * from "./api";
export * from "./user";
export * from "./phone";
export * from "./wiki";
export * from "./s3";

export const getDate = (dateString) =>
  new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
